import {
  EMBROIDERY_VERSION_V1,
  EMBROIDERY_VERSION_V2,
  EmbroideryVersion,
} from './embroideryVersion'
import { EmbroideryPurpose } from './types'
import { useEmbroideryV2Flag } from './useEmbroideryV2Flag'

// v2 is DTC-only; a B2B purpose (the My Uniform tab) stays on legacy and never records exposure.
export const useEmbroideryVersion = ({
  embroideryPurpose,
}: {
  embroideryPurpose: EmbroideryPurpose
}): EmbroideryVersion => {
  const isEligible = embroideryPurpose === 'DTC'

  const isV2FlagEnabled = useEmbroideryV2Flag({ skip: !isEligible })

  return isEligible && isV2FlagEnabled ? EMBROIDERY_VERSION_V2 : EMBROIDERY_VERSION_V1
}
